import { render } from "./LikeView.vue?vue&type=template&id=e72bb8aa&scoped=true"
import script from "./LikeView.vue?vue&type=script&lang=js"
export * from "./LikeView.vue?vue&type=script&lang=js"

import "./LikeView.vue?vue&type=style&index=0&id=e72bb8aa&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72bb8aa"]])

export default __exports__